export const LANG_COOKIE = "lang";
export const POLICY_ACCEPTED_COOKIE = "cokp";
export const COOKIE_MAX_AGE = 2147483647;

export const FORM_PREVIEW_PATH = "/ui/submitter/formpreview/:fieldset_id";
